import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';

import ScrollToTop from './services/Utils';
import PrivateRoute from './private';
import AuthLayout from './layouts/Auth.js';
import MainLayout from './layouts/MainPanel.js';

const queryClient = new QueryClient();

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop /> 
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route path={'/auth'} component={AuthLayout} />
        <PrivateRoute path={'/'} component={MainLayout} />
      </Switch>
    </QueryClientProvider>
  </BrowserRouter>,
  document.getElementById('root')
);